import { find, sortBy, replace } from 'lodash';

import { faAddressCard } from '@fortawesome/free-solid-svg-icons';
import { Component, ViewEncapsulation, Input, OnInit, OnChanges, Output, EventEmitter, ViewChild } from '@angular/core';
import SelfPayType from 'src/app/models/selfPayType';
import SpecialOpenEnrollmentType from 'src/app/models/specialOpenEnrollmentType';
import { env } from 'src/env/development';
import SelfPay from 'src/app/models/selfPay';
import * as dayjs from 'dayjs';
import Subscriber from 'src/app/models/subscriber';
import { collapseTextChangeRangesAcrossMultipleVersions } from 'typescript';

@Component({
  selector: 'self-pay-info',
  templateUrl: 'selfPay.info.component.html',
  styleUrls: [],
  providers: [],
  encapsulation: ViewEncapsulation.None
})
export class SelfPayInfoComponent implements OnInit, OnChanges {
  icons = {
    faAddressCard
  };
  @Output() continue: EventEmitter<void> = new EventEmitter<void>();
  @Output() previous: EventEmitter<void> = new EventEmitter();
  @Output() selectedSpecialOpenEnrollmentType: EventEmitter<SpecialOpenEnrollmentType> = new EventEmitter();
  @Input() requestType: SelfPayType;
  @Input() selectedSpecialOpenEnrollmentTypeId: string;
  @Input() agency: string;
  @Input() selfPay: SelfPay;
  @Input() specialOpenEnrollmentTypes: SpecialOpenEnrollmentType[];
  @Input() subscriber: Subscriber;
  selfPayTypesList: SpecialOpenEnrollmentType[] = [];
  oeSelfPayTypes: string[] = ['OEC', 'OER', 'OEU'];
  soeSelfPayTypes: string[] = ['SOEC', 'SOER', 'SOEU'];
  selectedSoeType: SpecialOpenEnrollmentType;
  showCustomSOEDescription = false;
  showCustomSOEDocTypes = false;
  soeSPTypesWithCustomDocs: string[] = ['GLEMO', 'MDP', 'MPNLA', 'NEED'];
  coverageYear: number;

  ngOnInit() {
    if (this.selectedSpecialOpenEnrollmentTypeId) 
      this.selectedSoeType = find(this.specialOpenEnrollmentTypes, soet => soet.specialOpenEnrollmentTypeId === this.selectedSpecialOpenEnrollmentTypeId);

    this.coverageYear = dayjs(this.selfPay.coverageEffectiveDate ?? new Date()).year();
  }

   ngOnChanges() {
    if (this.selfPay)
      this.selfPayTypesList = this.getSelfPayTypes();
   }

  pushContinue() {
    this.continue.emit();
  }

  pushCancel() {
    this.previous.emit();
  }

  selectSoeType(selectedSoeType: SpecialOpenEnrollmentType) {
    this.showCustomSOEDescription = env.soeTypesWithCustomDescriptions.includes(selectedSoeType.specialOpenEnrollmentTypeCode);
    this.showCustomSOEDocTypes = env.soeTypesWithCustomDocTypeInstructions.includes(selectedSoeType.specialOpenEnrollmentTypeCode);

    if (this.selectedSoeType === selectedSoeType)
      selectedSoeType = null;

    this.selectedSoeType = selectedSoeType;
    this.selectedSpecialOpenEnrollmentType.emit(selectedSoeType);
  }

  getSelfPayTypes(): SpecialOpenEnrollmentType[] {
    const excludeNames =
    [
      'HCAOEC', //'HCA OE Correction',
      'NE', //'Newly Eligible',
      'SUP', //'Supplemental',
      'APII', //'API Import',
      'RDP', //'Registering Domestic Partnership'
    ];

    if (this.selfPay.isSEBB) {
      //SEBB, exclude PEBB specific SOE types
      excludeNames.push('GLEMO');
      excludeNames.push('PASMED');
      excludeNames.push('CILIS');
    } else {
      //PEBB, exclude SEBB specific SOE types
      excludeNames.push('CSD');

      if (!this.selfPay.isLWOP)
        excludeNames.push('GLEM');
      
      excludeNames.push('PASMEDS');

      if (this.selfPay.isPebbLwopSOE)
        excludeNames.push('GLEMO');
    }

    //sort documents by sort order; exclude Partner API Verified (PA)
    this.specialOpenEnrollmentTypes.forEach(soet => { soet.documentTypes = sortBy(soet.documentTypes.filter(dt => dt.documentTypeCode !== 'PA'),'sortOrder');});

    return sortBy(
      this.specialOpenEnrollmentTypes.filter(soe => excludeNames.indexOf(soe.specialOpenEnrollmentTypeCode) === -1 
        && (soe.selfPayTypes.length == 0 || find(soe.selfPayTypes,spt=> spt.selfPayTypeCode == this.requestType.selfPayTypeCode))),
      'specialOpenEnrollmentTypeName');
  }

  canContinue(requestType: SelfPayType, selectedSoeType: SpecialOpenEnrollmentType): boolean {
    if (this.selfPay.isSOE)
      return !!selectedSoeType;

    return true;
  }

  cancelButtonLabel(selfPayTypeCode: string): string {
    if (this.selfPay.isSOE)
      return 'Cancel';

    return 'Previous';
  }

  continueButtonLabel(selfPayTypeCode: string): string {
      return 'Continue';
  }

  getTitle(selfPayTypeCode: string): string {
    if (this.selfPay.isInitialRequest) {
      if (this.selfPay.isRetiree)
        return `${this.selfPay.agency.agencyCode} retiree insurance coverage`;
      else if (this.selfPay.isLWOP)
        return `${this.selfPay.agency.agencyCode} Continuation Coverage (Unpaid Leave)`;
      else
        return `${this.selfPay.agency.agencyCode} Continuation Coverage (COBRA)`;
    }

    if (this.selfPay.isSOE)
      return 'Special Open Enrollment events';

    let program = 'Unpaid Leave';
    if (this.selfPay.isCobraOE)
      program = 'COBRA';
    else if (this.selfPay.isRetireeOE)
      return 'Retiree open enrollment changes';

    return `${this.selfPay.agency.agencyCode} Continuation Coverage (${program}) open enrollment changes`;
  }

  displaySPCustomDocs(soeTypeCode) {
    if (!find(this.soeSPTypesWithCustomDocs, soet=> soet == soeTypeCode)) {
      return false;
    }
    else {
      return true;
    }
  }
}
